if (!customElements.get('mini-mint-faq')) {
  customElements.define('mini-mint-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('hashchange', this.onHash);
        return;
      }
      this.initialized = true;
      this.input = this.querySelector('input[type="search"]');
      this.items = [...this.querySelectorAll('.mm-faq__item')];
      this.topics = [...this.querySelectorAll('[data-faq-topic]')];
      this.savedOpen = null;
      this.querySelectorAll('[data-faq-controls]').forEach(el => { el.hidden = false; });
      this.input.addEventListener('input', () => this.filter());
      this.querySelector('[data-faq-clear]').addEventListener('click', () => { this.reset(); this.input.focus(); });
      this.querySelector('[data-faq-expand]').addEventListener('click', () => this.items.filter(el => !el.hidden).forEach(el => { el.open = true; }));
      this.querySelector('[data-faq-collapse]').addEventListener('click', () => this.items.forEach(el => { el.open = false; }));
      this.querySelectorAll('.mm-faq__topics a').forEach(link => link.addEventListener('click', () => {
        this.reset();
        document.getElementById(link.hash.slice(1))?.focus({ preventScroll: true });
      }));
      this.onHash = () => {
        const target = document.getElementById(location.hash.slice(1));
        if (!target || !this.contains(target)) return;
        this.reset();
        if (target.matches('details')) target.open = true;
        target.scrollIntoView({ block: 'start' });
      };
      window.addEventListener('hashchange', this.onHash);
      this.filter();
      if (location.hash) this.onHash();
      this.addEventListener('shopify:block:select', event => {
        this.reset();
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      });
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); }
    reset() { this.input.value = ''; this.filter(); }
    filter() {
      const words = this.input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      if (words.length && !this.savedOpen) this.savedOpen = new Set(this.items.filter(el => el.open));
      let count = 0;
      this.items.forEach(item => {
        const matches = words.every(word => item.textContent.toLocaleLowerCase().includes(word));
        item.hidden = !matches;
        if (matches) count++;
        if (words.length) item.open = matches;
        else if (this.savedOpen) item.open = this.savedOpen.has(item);
      });
      if (!words.length) this.savedOpen = null;
      this.topics.forEach(topic => { topic.hidden = ![...topic.querySelectorAll('details')].some(el => !el.hidden); });
      this.querySelector('[data-faq-empty]').hidden = count !== 0;
      this.querySelector('[data-faq-status]').textContent = words.length ? `${count} matching ${count === 1 ? 'answer' : 'answers'}` : `${count} answers to explore`;
    }
  });
}
